<template>
	<div class="section-infopartners mt-10 pt-10 pb-10">
		<p class="text-h5 my-5 text-center primary--text font-weight-bold">Фотогалерея</p>

		<v-slide-group show-arrows>
			<v-slide-item v-for="(Item, index) in Previews" :key="index">
				<v-dialog v-model="Active[index]" scrollable>
					<template v-slot:activator="{ on, attrs }">
						<v-img v-on="on" v-bind="attrs" :src="Item" max-width="256" height="172" class="mx-1" />
					</template>
					<v-card style="overflow: hidden;  position: relative">
						<v-img :src="Items[currentIndex]" height="100%" contain />
						<v-btn @click="$set(Active, index, false)" color="primary" small absolute top right fab class="mt-8">
							<v-icon>mdi-close</v-icon>
						</v-btn>

						<v-btn 
							v-if="currentIndex > 0"
							@click="currentIndex--" 
							color="primary" 
							absolute 
							top 
							left 
							fab
							:x-large="!$vuetify.breakpoint.xs"
							:small="$vuetify.breakpoint.xs"
							text
							outlined
							:class="$vuetify.breakpoint.xs ? 'ml-n1' : 'ml-4'"
							elevation="0"
							style="top: 50%; transform: translateY(-50%);"
						>
							<v-icon>mdi-chevron-left</v-icon>
						</v-btn>
						
						<!-- Кнопка следующего изображения -->
						<v-btn 
							v-if="currentIndex < Items.length - 1"
							@click="currentIndex++" 
							color="primary" 
							absolute 
							top 
							right 
							fab
							:x-large="!$vuetify.breakpoint.xs"
							:small="$vuetify.breakpoint.xs"
							text
							outlined
							elevation="0"
							:class="$vuetify.breakpoint.xs ? 'mr-n1' : 'mr-12'"
							style="top: 50%; transform: translateY(-50%);"
						>
							<v-icon>mdi-chevron-right</v-icon>
						</v-btn>
					</v-card>
				</v-dialog>
			</v-slide-item>
		</v-slide-group>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
	name: 'SectionGallery',
	data: () => ({
		Active: [] as Array<boolean>,
		currentIndex: 0,
		Items: [
			require('./../assets/images/gallery/2025/main/Gum_Katok_01.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_02.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_03.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_04.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_05.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_06.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_07.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_08.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_09.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_010.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_011.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_012.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_013.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_014.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_015.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_016.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_017.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_018.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_019.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_020.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_021.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_022.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_023.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_024.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_025.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_026.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_027.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_028.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_029.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_031.jpg'),
			require('./../assets/images/gallery/2025/main/Gum_Katok_032.jpg'),
		],
		Previews: [
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_01.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_02.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_03.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_04.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_05.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_06.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_07.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_08.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_09.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_010.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_011.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_012.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_013.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_014.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_015.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_016.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_017.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_018.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_019.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_020.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_021.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_022.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_023.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_024.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_025.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_026.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_027.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_028.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_029.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_031.jpg'),
			require('./../assets/images/gallery/2025/main/1x1/Gum_Katok_032.jpg'),
		],
	}),
	watch: {
		Active: {
			handler(newVal) {
				// Когда открывается диалог, устанавливаем currentIndex в индекс открытого изображения
				const openIndex = newVal.findIndex((item: any) => item === true);
				if (openIndex !== -1) {
					this.currentIndex = openIndex;
				}
			},
			deep: true
		}
	}
});
</script>
